var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTimeclock = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "7lzcyc2lra",
  x1: "100%",
  x2: "0%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#B620E0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F7B500"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "70io5c5wlb",
  x1: "100%",
  x2: ".391%",
  y1: "0%",
  y2: "99.609%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#AA3BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#E9A1FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "y8927i2s5c",
  x1: "100%",
  x2: ".391%",
  y1: "0%",
  y2: "99.609%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFBFFA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFEFFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "knk3xytq2d",
  x1: "84.722%",
  x2: "15.549%",
  y1: "0%",
  y2: "99.609%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#AA3BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#DA63FF"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-357 -30) translate(357 30)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "url(#7lzcyc2lra)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "url(#70io5c5wlb)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 8,
  fill: "url(#y8927i2s5c)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#knk3xytq2d)",
  d: "M9.5 5.5c.552 0 1 .448 1 1v3h2c.552 0 1 .448 1 1s-.448 1-1 1h-3c-.552 0-1-.448-1-1v-4c0-.552.448-1 1-1z"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTimeclock);
export default ForwardRef;